import { Entity } from "../../Entity";
import SubscriptionFactory from "../../../Entity/Factories/SubscriptionFactory";
import { SubscriptionTypeInterface } from "./SubscriptionType/SubscriptionTypeInterface";
import { SubscriptionInterface } from "./SubscriptionInterface";
import { FactoryInterface } from "../../FactoryInterface";

class Subscription extends Entity implements SubscriptionInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return SubscriptionFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get userId(): number {
    return this.data.userId;
  }

  get subscriptionType(): SubscriptionTypeInterface {
    return this.data.subscriptionType;
  }

  get entityId(): number {
    return this.data.entityId;
  }

  get subscribed(): boolean {
    return this.data.subscribed;
  }
}

export { Subscription }
